module.exports = function (data) {
    return {
        cart: {
            price: {
                shippingMethod: data.DeliveryMethod,
                deliveryAddress: data.DeliveryAddress,
                deliveryTime: data.DeliveryTime,
            },
        },
    };
};



// WEBPACK FOOTER //
// ./src/fulfilment/dtmmapper/delivery-analytics-mapper.js